import { forwardRef, useEffect, useRef, useState } from "react";
import config from "../../../../../../application/config/config";
import { geocodeByLatLng } from 'react-google-places-autocomplete';
import { GoogleMap, Marker, StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import { Input, Label } from "reactstrap";

export const AddressAutoComplete = forwardRef((props, ref) => {
    const [value, updateValue] = useState({
        fullAddress: props.value?.fullAddress || '',
        complement: props.value?.complement || ''
    });
    const [latLng, setLatLng] = useState({ lat: props.value?.lat, lng: props.value?.lng });
    const inputRef = useRef();
    let className = '';

    const containerStyle = {
        width: '100%',
        height: '400px',
        marginTop: '1rem'
    };

    const handleMarkerDragEnd = (event) => {
        const { latLng } = event;
        const lat = latLng.lat();
        const lng = latLng.lng();

        setLatLng({ lat, lng });
        geocodeByLatLng({ lat, lng }).then((result) => {
            const address = result[0].formatted_address;
            updateValue(prev => ({ ...prev, fullAddress: address }));
            const target = {
                name: props.name,
                value: { fullAddress: address, lat, lng, complement: value?.complement || '' }
            };
            props.onChange({ target });
        })
    };

    const handlePlacesChanged = () => {
        const [place] = inputRef.current.getPlaces();
        if (place) {
            const latLngResponse = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
            setLatLng(latLngResponse);
            updateValue(prev => ({ ...prev, fullAddress: place.formatted_address }));
            const target = {
                name: props.name,
                value: { fullAddress: place.formatted_address, lat: latLngResponse.lat, lng: latLngResponse.lng, complement: value?.complement || '' }
            };
            props.onChange({ target });
        }
    }


    const handleChange = element => {
        const { name, value: val } = element.target;
        if (name === 'complement') {
            updateValue(prev => ({ ...prev, complement: val }));
            // propaga mudança do complemento também
            const target = {
                name: props.name,
                value: { fullAddress: value.fullAddress, lat: latLng?.lat, lng: latLng?.lng, complement: val }
            };
            props.onChange({ target });
        } else {
            // assume campo principal de endereço
            updateValue(prev => ({ ...prev, fullAddress: val }));
        }
    };

    if (props.error) {
        className = "is-invalid";
    }

    useEffect(() => {
        updateValue({
            fullAddress: props.value?.fullAddress || '',
            complement: props.value?.complement || ''
        });
    }, [props.value]);

    return (
        <div ref={ref}>
            <LoadScript googleMapsApiKey={config.gmaps_key} region="BR" libraries={["places"]}>
                <StandaloneSearchBox
                    onLoad={ref => (inputRef.current = ref)}
                    onPlacesChanged={handlePlacesChanged}
                >
                    <>
                        <Label>Endereço</Label>
                        <Input
                            id={'id_' + props.name}
                            className={className}
                            value={value.fullAddress}
                            onChange={handleChange}
                            type={props.type}
                            name={props.name}
                            readOnly={props.readOnly}
                            autoFocus={props.autoFocus ? true : false}
                            maxLength={props.maxLength}
                            placeholder="Digite um endereço"
                        />
                    </>
                </StandaloneSearchBox>
                {props.hasComplement && (
                    <>
                        <Label className="mt-1">Complemento</Label>
                        <Input
                            type="text"
                            name="complement"
                            onChange={handleChange}
                            value={value.complement}
                            readOnly={props.readOnly}
                        />
                    </>
                )}

                {latLng && (
                    <GoogleMap mapContainerStyle={containerStyle} center={latLng} zoom={17}>
                        <Marker
                            position={latLng}
                            draggable={true}
                            onDragEnd={handleMarkerDragEnd}
                        />
                    </GoogleMap>
                )}
                {props.error && (
                    <span
                        className="error invalid-feedback"
                        style={{ display: 'inline' }}>
                        {props.error}
                    </span>
                )}
            </LoadScript>
        </div >
    );
})
